import React, { useEffect, useState } from 'react'

interface Props {
  count: number
}

const NotificationBadge: React.FC<Props> = ({ count }) => {
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (count > 0) {
      setIsAnimating(true)
      const timer = setTimeout(() => setIsAnimating(false), 1000)
      return () => clearTimeout(timer)
    }
  }, [count])

  if (!count || count <= 0) return null
  return (
    <>
      {/* Anel pulsante ao redor do badge */}
      <span
        className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-red-500 opacity-60 animate-ping"
        aria-hidden="true"
        style={{ animationDuration: '4s' }}
      />
      {/* Badge principal com animações */}
      <span
        className={`absolute -top-1 -right-1 inline-flex items-center justify-center rounded-full bg-gradient-to-r from-red-600 to-red-500 text-white text-[10px] font-bold leading-none min-w-[18px] h-[18px] px-1.5 shadow-lg ring-2 ring-red-300 ring-opacity-50 z-10 transition-all duration-300 ${
          isAnimating ? 'animate-badge-bounce' : 'animate-badge-pulse-slow'
        }`}
        aria-label={`${count} notificações não lidas`}
      >
        {count > 99 ? '99+' : count}
      </span>
    </>
  )
}

export default NotificationBadge


